import { ColumnState } from "@ag-grid-community/core";

import IFieldModel from "@mapmycustomers/shared/types/fieldModel/IFieldModel";
import ColumnModel from "@mapmycustomers/shared/types/viewModel/internalModel/ColumnModel";
import { isDefined } from "@mapmycustomers/shared/util/assert";

import loggingService from "@app/util/logging";

const hasColId = (columnState: ColumnState): columnState is ColumnState & { colId: string } =>
  !!columnState.colId;

// basically documentation says pinned can only be "left" or "right", but the type in
// ColumnState also includes boolean, string, and null types. Replacing all such
// types with undefined.
export const convertPinned = (pinned: ColumnState["pinned"]): "left" | "right" | undefined =>
  pinned !== "left" && pinned !== "right" ? undefined : pinned;

const convertFromAgGridColumnModel = (
  columnState: ColumnState[],
  fieldModel: IFieldModel
): ColumnModel =>
  columnState
    .filter(hasColId)
    .map(({ colId, hide, pinned, width }) => {
      const field = fieldModel.getByName(colId);
      if (!field) {
        loggingService.warning("Failed to get field by colId", { colId });
        return undefined;
      }
      return { field, pinned: convertPinned(pinned), visible: !hide, width };
    })
    .filter(isDefined);

export default convertFromAgGridColumnModel;
